// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"451551c9","164":"86bbb006","254":"17fe183f","301":"16f7d1e9","444":"729f24aa","453":"a85e2675"}[chunkId] + ".chunk.js";
};